export default "__VITE_ASSET__3WElStek__"